import { AppThunk } from 'store/types';
import {
  setSendToSpruceErrorAction,
  setSendToSpruceFetchStatusAction,
  setVendorOrderDataAction,
  setVendorOrderErrorAction,
  setVendorOrderFetchStatusAction,
} from './reducer';
import { createFetchedSuccess, createFetchedWithError, createFetchInProgress } from 'types/rest/IFetchStatus';
import { eTitleSearchStatus } from 'types/order/title/eTitleSearchStatus';
import {
  createDefaultVendorOrderInformationData,
  IVendorOrderInformationData,
} from '../../../types/vendorDashboard/IVendorOrderInformation';
import { getOrderAsync, sendTitleSearchToSpruceAsync } from '../../../API/vendorDashboard/VendorAPI';
import { getTitleReport } from '../../order/titleInformation/dispatch';

export const getVendorOrderData =
  (orderId: string): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setVendorOrderErrorAction(undefined));
      dispatch(setVendorOrderFetchStatusAction(createFetchInProgress()));
      const response: IVendorOrderInformationData = await getOrderAsync(orderId);
      if (response?.titleCommitmentId) {
        dispatch(getTitleReport(orderId));
      }
      dispatch(setVendorOrderDataAction({ orderId, value: response }));
      dispatch(setVendorOrderFetchStatusAction(createFetchedSuccess()));
    } catch (e: any) {
      dispatch(setVendorOrderDataAction({ orderId, value: { ...createDefaultVendorOrderInformationData(), orderId } }));
      dispatch(setVendorOrderFetchStatusAction(createFetchedWithError()));
      dispatch(setVendorOrderErrorAction(e.message));
    }
  };

export const sendToSpruceTitleSearch =
  (orderId: string, titleSearchRequestId: string): AppThunk =>
  async (dispatch, getState) => {
    try {
      dispatch(setSendToSpruceErrorAction(undefined));
      dispatch(setSendToSpruceFetchStatusAction(createFetchInProgress()));
      await sendTitleSearchToSpruceAsync(titleSearchRequestId);
      const orderInfo = getState().vendorDashboard.order.order[orderId];
      dispatch(setVendorOrderDataAction({ orderId, value: { ...orderInfo, status: eTitleSearchStatus.sent } }));
      dispatch(setSendToSpruceFetchStatusAction(createFetchedSuccess()));
    } catch (e: any) {
      dispatch(setSendToSpruceFetchStatusAction(createFetchedWithError()));
      dispatch(setSendToSpruceErrorAction(e.message || e));
    }
  };
